import React, { useState } from 'react';
import { WishlistCheckboxButton, showNotification } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks';
import { NotificationTemplates } from 'types/notification';

export type Props = {
  productId: string;
  inShoplist: boolean;
  hasText?: boolean;
  size: 's' | 'm' | 'l';
  onShoplistToggle: (productId: string, flowQty: number) => void;
};

export const WishlistButton: React.FC<Props> = ({
  productId,
  hasText = false,
  size,
  inShoplist,
  onShoplistToggle,
}) => {
  const { t } = useTranslation();
  const breakpoints = useBreakpoints();
  const isDesktop = breakpoints?.largeDesktop || breakpoints?.desktop;
  const [inWishlist, setInWishlist] = useState(inShoplist);

  const tooltipText = inWishlist
    ? t('ui.product-card.shopping-list-tooltip-remove')
    : t('ui.product-card.shopping-list-tooltip-add');
  const wishlistText = inWishlist
    ? t('ui.product-card.shopping-list-checkbox-label-checked')
    : t('ui.product-card.shopping-list-checkbox-label');

  const changeHandler = () => {
    setInWishlist((prev) => {
      const nextValue = !prev;
      onShoplistToggle(productId, nextValue ? 1 : -1);
      const title = nextValue
        ? t('ui.product-card.shopping-list-snack-add')
        : t('ui.product-card.shopping-list-snack-remove');
      showNotification({
        templateId: NotificationTemplates.WishList,
        data: { title: title },
      });
      return nextValue;
    });
  };

  return (
    <WishlistCheckboxButton
      isChecked={inShoplist}
      isInteractive={!!productId}
      size={size}
      text={hasText ? wishlistText : undefined}
      tooltipText={tooltipText}
      isDesktop={isDesktop}
      onClick={changeHandler}
    />
  );
};
